<template>
  <layout-list-default :meals="meals" />
</template>

<script>
import LayoutListDefault from "./layout-list-default"

export default {
  maxMeals: 12,
  slicer: LayoutListDefault.slicer,
  name: "layout-list-white",
  props: ["meals"],
  components: { LayoutListDefault }
}
</script>

<style lang="scss" scoped>
.layout {
  background-color: white;
  ::v-deep .item {
    color: black;
    border-bottom: 0.1px solid lightgray;
    .badges {
      .badge {
        filter: drop-shadow(0.1em 0.1em 0.1em rgb(196, 13, 68));
      }
    }
  }
}
</style>
